<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>
          <span
            v-if="numberingRecord.objecttype"
          >{{numberingRecord.objecttype.DocumentName}} - Series Setup</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/document-numbering">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense no-gutters>
          <v-col cols="12">
            <v-btn color="accent" small @click="openDefaultDialog">
              <v-icon left>mdi-plus</v-icon>Set As Default
            </v-btn>

            <v-btn right absolute color="accent" small @click="openSeriesDialog">
              <v-icon left>mdi-plus</v-icon>Define New
            </v-btn>
          </v-col>
        </v-row>

        <!-- series list -->
        <v-row>
          <v-col cols="12">
            <v-data-table
              hide-default-footer
              v-model="selectedItems"
              :headers="headers"
              :items="seriesData"
              :items-per-page="itemsPerPage"
              :search="search"
              :single-select="singleSelect"
              @item-selected="clickedItem"
              show-select
            >
              <!-- lock and cancellation editor -->
              <template v-slot:item.SeriesName="props">
                <span v-if="props.item.id == numberingRecord.DfltSeries" style="color: blue">{{props.item.SeriesName}} (Default Series)</span>
                <span v-else>{{props.item.SeriesName}}</span>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>

          <v-col col="12">
            <v-btn class="accent" :loading="updateLoading" @click="updateSeries" small>Update</v-btn>
          </v-col>
        </v-row>
        <!-- end of series list -->

        <!-- start of entry dialog -->
        <v-dialog v-model="dialog" max-width="900px">
          <v-card>
            <v-toolbar dense dark color="primary">
              <v-toolbar-title>New Series Setup</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="4">
                    <v-text-field label="Name" v-model="record.SeriesName" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                      label="First Number"
                      type="Number"
                      v-model="record.InitialNum"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="4">
                    <v-text-field label="Last Number" type="Number" v-model="record.LastNum" outlined dense></v-text-field>
                  </v-col>-->

                  <v-col cols="4">
                    <v-text-field label="Prefix" v-model="record.BeginStr" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field label="Suffix" v-model="record.EndStr" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field label="Remarks" v-model="record.Remark" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field label="No Of Digits." v-model="record.NumSize" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" :loading="loading" @click="saveSeries">
                      <v-icon left>mdi-content-save</v-icon>Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of entry dialog -->

        <!-- start of default dialog -->
        <v-dialog
          v-model="defaultDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="accent">
              <v-toolbar-title>
                <v-btn icon dark @click="defaultDialog = false">
                  <v-icon dark>mdi-keyboard-backspace</v-icon>
                </v-btn>Set Default Numbering series
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="defaultDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row justify="center">
                <v-col cols="6">
                  <v-row dense>
                    <v-col cols="12">
                      <h4>Series: {{selectedItem.SeriesName}}</h4>
                    </v-col>

                    <v-col cols="12">
                      <h3>Do you want to set this series as the default?</h3>
                    </v-col>

                    <v-col cols="12">
                      <v-btn class="accent" small @click="setDefault">Yes</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of default dialog -->

        <!-- users dialog -->
        <v-dialog v-model="usersDialog" max-width="600px">
          <v-card>
            <v-toolbar dark color="accent">
              <v-toolbar-title>Select Users</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="usersDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    v-model="selectedUsers"
                    :headers="userHeaders"
                    :items="users"
                    show-select
                    item-key="id"
                  ></v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn color="accent" small @click="setCertainUsers">Ok</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of users list dialog -->

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      userGroup: null,
      itemsPerPage: 100,
      dialog: false,
      usersDialog: false,
      defaultDialog: false,
      loading: false,
      updateLoading: false,
      singleSelect: true,
      selectedItem: {},
      selectedItems: [],
      selectedUsers: [],
      users: [],
      Locked: "N",
      IsForCncl: "N",
      search: null,
      numberingRecord: {},
      record: {},
      seriesData: [],
      headers: [
        { text: "Name", value: "SeriesName" },
        { text: "First Number", value: "InitialNum" },
        { text: "Next Number", value: "NextNumber" },
        { text: "Prefix", value: "BeginStr" },
        { text: "Suffix", value: "EndStr" },
        { text: "No Of. Digits", value: "NumSize" },
      ],
      userHeaders: [{ text: "Name", value: "name" }],
    };
  },
  watch: {
    "$route.params.id": {
      handler: "getData",
      immediate: true,
    },
  },
  methods: {
    updateSeries() {
      const url = "/documentnumbering/updateseries";
      const self = this;
      const data = { Series: this.seriesData };
      self.updateLoading = true;
      this.$store
        .dispatch("post", { url, data })
        .then(() => {
          location.reload();
        })
        .catch(() => {
        });
    },
    setCertainUsers() {
      this.selectedUsers;
      const series = this.selectedItem;
      const ids = this.selectedUsers.map((record) => {
        return record.id;
      });
      const data = { Series: series.id, users: ids };
      const url = "/documentnumbering/set-default-selected-users";
      this.saveDefaults(url, data);
      this.usersDialog = false;
    },
    setDefault() {
      let data = {};
      let url = null;
      const series = this.selectedItem;
      data = { Series: series.id };
      url = "/documentnumbering/set-default-all-users";
      this.saveDefaults(url, data);
    },
    openSeriesDialog() {
      this.dialog = true;
    },
    selectedRadio() {
    },
    clickedItem($event) {
      this.selectedItem = $event.item;
    },
    openDefaultDialog() {
      if (this.selectedItem.SeriesName == undefined) {
        this.$refs.snackbar.show("Please select a series first!", "red");
      } else {
        this.defaultDialog = true;
      }
    },
    saveDefaults(url, data) {
      const self = this;
      self.loading = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(
              "Default series created successfully",
              "green"
            );
            self.defaultDialog = false;
          } else {
            self.$refs.snackbar.show(res.ResultCode, "red");
          }
        })
        .catch(() => {
        });
    },
    saveSeries() {
      // const LastNumLength = this.record.LastNum.length;
      // const NumSize = this.record.NumSize;
      // if (NumSize !== undefined && LastNumLength > NumSize) {
      //   this.$refs.snackbar.show(
      //     "Last Number length greater than No. of Digits",
      //     "red"
      //   );
      // } else {
      this.record.ObjectCode = this.numberingRecord.id;
      // this.record.Locked = this.Locked || null;
      // this.record.IsForCncl = this.IsForCncl || null;
      const data = this.record;
      const url = "/documentnumbering/createseries";
      const self = this;
      self.loading = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if(res.ResultCode == 1200) {
            location.reload();
          } else {
            self.$refs.snackbar(res.ResultDesc, "red");
          }
        })
        .catch(() => {
          // this.$refs.snackbar.show(err, "red");
        });
      // }
    },
    getData(val) {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/documentnumbering/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.numberingRecord = res.ResponseData;
            self.seriesData = res.ResponseData.series;
            self.loading = false;
          } else {
            self.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(() => {
        });
    },
    getUsers() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          self.users = res;
          self.loading = false;
        })
        .catch(() => {
        });
    },
  },
  created() {
    this.getUsers();
  },
};
</script>

<style lang="scss" scoped>
</style>